<div *ngIf="Attachement" class="mt-10 mb-30" [busyIf]="isloading" [style.width]="width" [style.height]="height">
    <div class="mb-4">
        <button
            *ngIf="ShowRemoveButton"
            type="button"
            (click)="RemoveAttachment()"
            class="btn btn-outline-danger btn-sm px-8"
        >
            <i class="la la-times"></i>
            {{ RemoveAttachementLabel }}
        </button>
        <button
            *ngIf="
                Attachement?.fileMimeType?.includes('application') && ShowPreviewMedia && PreviewButtonType == 'Button'
            "
            type="button"
            class="btn btn-outline-primary btn-sm px-8"
            (click)="showfile()"
        >
            <i class="fas fa-tv"></i>
            {{ 'ShowFile' | localize }}
        </button>
        <a
            class="mx-1"
            *ngIf="
                Attachement?.fileMimeType?.includes('application') && ShowPreviewMedia && PreviewButtonType == 'Link'
            "
            (click)="showfile()"
        >
            <strong>
                <u>
                    {{ 'ShowFile' | localize }}
                </u>
            </strong>
        </a>
        <button
            *ngIf="ShowDownloadLinkButton"
            type="button"
            class="btn btn-outline-primary btn-sm px-8"
            (click)="DownloadFile()"
        >
            <i *ngIf="Attachement?.fileMimeType?.includes('application/pdf')" class="fas fa-file-pdf"></i>
            <i
                *ngIf="
                    Attachement?.fileMimeType?.includes(
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    )
                "
                class="fa fa-file-excel"
            ></i>
            <i *ngIf="Attachement?.fileMimeType?.includes('image')" class="fas fa-image"></i>
            <i *ngIf="Attachement?.fileMimeType?.includes('video')" class="fas fa-film"></i>
            {{ 'DownloadFile' | localize }}
        </button>
    </div>
    <div *ngIf="ShowPreviewMedia">
        <div [style.width]="width" [style.height]="height" *ngIf="Attachement?.fileMimeType?.includes('image')">
            <img
                [src]="Attachement.fileContent"
                alt="news-photo-02"
                (load)="showloading()"
                style="height: 100%; width: 100%; object-fit: contain"
            />
        </div>
        <div [style.width]="width" [style.height]="height" *ngIf="Attachement?.fileMimeType?.includes('video')">
            <video
                preload="metadata"
                class="embed-responsive"
                (loadeddata)="showloading()"
                style="height: 100%; width: 100%"
                controlsList="nodownload"
                controls
                #video
            >
                <source [src]="Attachement?.fileContent" />
            </video>
        </div>
    </div>
    <div
        *ngIf="ShowFileInfo"
        [style.width]="width"
        class="alert alert-secondary my-3"
        style="border-radius: 10px"
        role="alert"
    >
        <div class="row">
            <div class="col-md-6 text-truncate">
                <strong>{{ l('FileName') }}</strong>
                {{ Attachement?.fileName }}
            </div>
            <div class="col-md-6">
                <strong>{{ l('FileSize') }}</strong>
                {{ filesize }}
            </div>
        </div>
    </div>
</div>
